<div class="inventory-cart-shipping">
    <hr />
    <h3><i class="fa fa-truck" aria-hidden="true"></i> &nbsp;{{'shoppingCart.shippingInformation.title' | translate}}
    </h3>
    <hr />
    <br />
    <form [formGroup]="shippingForm" class="row g-3">
        <!-- <div class="col-md-12 col-sm-12"> -->
            <div class="col-md-6 col-sm-6">
                <label for="city">{{'shoppingCart.shippingInformation.labels.firstName' | translate}}</label>
                <input (blur)="updateShippingAddress()" (keyup.tab)="updateShippingAddress()"
                    formControlName="custFirst" type="text" class="form-control input-sm" placeholder="" />
                <div *ngIf="shippingForm.controls['custFirst'].hasError('required') && shippingForm.controls['custFirst'].touched"
                    class="alert alert-danger">{{'shoppingCart.shippingInformation.validation.errors.firstName' |
                    translate}}</div>
            </div>
            <div class="col-md-6 col-sm-6">
                <label for="city">{{'shoppingCart.shippingInformation.labels.lastName' | translate}}</label>
                <input (blur)="updateShippingAddress()" (keyup.tab)="updateShippingAddress()" formControlName="custLast"
                    type="text" class="form-control input-sm" placeholder="" />
                <div *ngIf="shippingForm.controls['custLast'].hasError('required') && shippingForm.controls['custLast'].touched"
                    class="alert alert-danger">{{'shoppingCart.shippingInformation.validation.errors.lastName' |
                    translate}}</div>
            </div>
            <div class="col-md-6 col-sm-6">
                <label for="address">{{'shoppingCart.shippingInformation.labels.street1' | translate}}</label>
                <input (blur)="updateShippingAddress()" (keyup.tab)="updateShippingAddress()" type="text"
                    formControlName="custStreet" class="form-control input-sm" />
                <div *ngIf="shippingForm.controls['custStreet'].hasError('required') && shippingForm.controls['custStreet'].touched"
                    class="alert alert-danger">{{'shoppingCart.shippingInformation.validation.errors.street1' |
                    translate}}</div>
            </div>
            <div class="col-md-6 col-sm-6">
                <label for="address">{{'shoppingCart.shippingInformation.labels.street2' | translate}}</label>
                <input (blur)="updateShippingAddress()" (keyup.tab)="updateShippingAddress()" type="text"
                    formControlName="custStreet2" class="form-control input-sm" />
            </div>
            <div class="col-md-6 col-sm-6">
                <label for="pincode">{{'shoppingCart.shippingInformation.labels.zip' | translate}}</label>
                <input (blur)="getZipInfo();updateShippingAddress();"
                    (keyup.tab)="getZipInfo();updateShippingAddress();" formControlName="custZip" type="text"
                    class="form-control input-sm" placeholder="" />
                <div *ngIf="shippingForm.controls['custZip'].hasError('required') && shippingForm.controls['custZip'].touched"
                    class="alert alert-danger">{{'shoppingCart.shippingInformation.validation.errors.zip' | translate}}
                </div>
            </div>
            <div class="col-md-6 col-sm-6">
                <label for="city">{{'shoppingCart.shippingInformation.labels.city' | translate}}</label>
                <select formControlName="custCity" class="form-select form-select-sm">
                    <option *ngFor="let city of cities">{{city}}</option>
                </select>
                <!-- <input (blur)="updateShippingAddress()" (keyup.tab)="updateShippingAddress()" formControlName="custCity" type="text" class="form-control input-sm"
                        placeholder=""> -->
                <div *ngIf="shippingForm.controls['custCity'].hasError('required') && shippingForm.controls['custCity'].touched"
                    class="alert alert-danger">{{'shoppingCart.shippingInformation.validation.errors.city' | translate}}
                </div>
            </div>
            <div class="col-md-6 col-sm-6">
                <label for="state">{{'shoppingCart.shippingInformation.labels.state' | translate}}</label>
                <select formControlName="custState" class="form-select form-select-sm">
                    <option *ngFor="let state of states">{{state}}</option>
                </select>
                <!-- <select (blur)="updateShippingAddress()" (keyup.tab)="updateShippingAddress()" formControlName="custState" class="form-control input-lg" placeholder="">
                        <option *ngFor="let state of states" [value]="state">{{state}}</option>
                    </select> -->
                <div *ngIf="shippingForm.controls['custState'].hasError('required') && shippingForm.controls['custState'].touched"
                    class="alert alert-danger">{{'shoppingCart.shippingInformation.validation.errors.state' |
                    translate}}</div>
            </div>
            <div class="col-md-6 col-sm-6">
                <label for="state">{{'shoppingCart.shippingInformation.labels.county' | translate}}</label>
                <select formControlName="custCounty" class="form-select form-select-sm">
                    <option *ngFor="let county of counties">{{county}}</option>
                </select>
                <!-- <select (blur)="updateShippingAddress()" (keyup.tab)="updateShippingAddress()" formControlName="custState" class="form-control input-lg" placeholder="">
                        <option *ngFor="let state of states" [value]="state">{{state}}</option>
                    </select> -->
                <div *ngIf="shippingForm.controls['custCounty'].hasError('required') && shippingForm.controls['custCounty'].touched"
                    class="alert alert-danger">{{'shoppingCart.shippingInformation.validation.errors.county' |
                    translate}}</div>
            </div>
            <div class="col-md-6 col-sm-6">
                <label for="country">{{'shoppingCart.shippingInformation.labels.phone' | translate}}</label>
                <input (blur)="updateShippingAddress()" (keyup.tab)="updateShippingAddress()"
                    formControlName="custPhone" type="text" class="form-control input-sm" placeholder=""
                    mask="000-000-0000">
                <div *ngIf="shippingForm.controls['custPhone'].hasError('required') && shippingForm.controls['custPhone'].touched"
                    class="alert alert-danger">{{'shoppingCart.shippingInformation.validation.errors.phone' |
                    translate}}</div>
            </div>
            <div class="col-md-6 col-sm-6">
                <label for="country">{{'shoppingCart.shippingInformation.labels.email' | translate}}</label>
                <input (blur)="updateShippingAddress()" (keyup.tab)="updateShippingAddress()"
                    formControlName="custEmail" type="email" class="form-control input-sm" placeholder="">
                <div *ngIf="shippingForm.controls['custEmail'].hasError('required') && shippingForm.controls['custEmail'].touched"
                    class="alert alert-danger">{{'shoppingCart.shippingInformation.validation.errors.email' |
                    translate}}</div>
            </div>
            <div class="col-md-12 col-sm-12 inventory-checkout-total hidden-xs">
                <br /><br />
            </div>
        <!-- </div> -->
    </form>
</div>
<br />
